<template>
  <v-parallax :src="require(`@/assets/${img}`)" style="height:90vh">
    <v-row align="center" justify="center">
      <v-col class="text-center" md="5">
        <v-card class="pa-5">
          <h1 v-html="title"></h1>
          <p class="mb-0" v-html="text"></p>
          <v-btn
            color="#D9EEFF"
            v-if="btn"
            class="mt-3"
            :href="to"
            target="_blank"
            >{{ btn }}</v-btn
          >
        </v-card>
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
export default {
  props: {
    img: String,
    title: String,
    text: String,
    btn: String,
    to: String
  }
};
</script>

<style lang="scss" scoped>
.Masthead {
  z-index: inherit;
}
p {
  color: #707070;
}
</style>
